export const useScroll = () => {
  let isScrolledToTop = $state(true);
  let deltaY = $state(0);

  $effect(() => {
    const onWheel = (wheelEvent: WheelEvent) => {
      deltaY = wheelEvent.deltaY;
    };

    let oldClientY = 0;
    const touchMove = (touchMove: TouchEvent) => {
      const latestTouch = touchMove.touches.item(0);
      if (!latestTouch) {
        return;
      }
      deltaY = oldClientY - latestTouch.clientY;
      oldClientY = latestTouch.clientY;
    };

    const onScroll = () => {
      isScrolledToTop = window.scrollY < 5;
    };

    onScroll();

    document.addEventListener('scroll', onScroll);
    document.addEventListener('wheel', onWheel);
    document.addEventListener('touchmove', touchMove);
    return () => {
      document.removeEventListener('scroll', onScroll);
      document.removeEventListener('wheel', onWheel);
      document.removeEventListener('touchmove', touchMove);
    };
  });
  return {
    get scrollDirection() {
      return deltaY <= 0 ? 'up' : 'down';
    },
    get isScrolledToTop() {
      return isScrolledToTop;
    },
  };
};
